import {
    BannersEditMassActions,
    CHANGE_MASS_ACTIONS_TEXT_BULK_ADDITIONAL_TEXT_TUMBLER,
    CHANGE_MASS_ACTIONS_TEXT_BULK_NEW_TEXT,
    CHANGE_MASS_ACTIONS_TEXT_BULK_RADIO,
    CHANGE_MASS_ACTIONS_TEXT_BULK_SITE_LINKS_TUMBLER,
    CHANGE_MASS_ACTIONS_TEXT_BULK_TITLE_TUMBLER,
    CLOSE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR,
    ON_MASS_ACTIONS_TEXT_BULK_SOURCE_TEXT_CHANGE,
    OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { getMassActionsCheckBoxState } from '../../../service/BannersEditMassActionsHelpers/BannersEditMassActionsHelpers';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsTextBulkReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR:
        case CLOSE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR: {
            return bannersEditMassActionsInitialState;
        }
        case OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        textBulkReplacementEditorVisible: true
                    },
                    data: {
                        ...state[action.massActionId].data
                    }
                }
            };
        }
        case CHANGE_MASS_ACTIONS_TEXT_BULK_SITE_LINKS_TUMBLER: {
            const isTitleActive =
                state[action.massActionId].data.isTitleTumblerChecked;
            const isAdditionalTextActive =
                state[action.massActionId].data.isAdditionalTextTumblerChecked;
            const isOldSiteLinksActive =
                state[action.massActionId].data.isSiteLinksTumblerChecked;
            const isSiteLinksActive = !state[action.massActionId].data
                .isSiteLinksTumblerChecked;

            const [
                isTitleTumblerChecked,
                isAdditionalTextTumblerChecked,
                isSiteLinksTumblerChecked
            ] = getMassActionsCheckBoxState(
                [isTitleActive, isAdditionalTextActive, isSiteLinksActive],
                [isTitleActive, isAdditionalTextActive, isOldSiteLinksActive]
            );

            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        isTitleTumblerChecked,
                        isAdditionalTextTumblerChecked,
                        isSiteLinksTumblerChecked
                    }
                }
            };
        }
        case CHANGE_MASS_ACTIONS_TEXT_BULK_TITLE_TUMBLER: {
            const isTitleActive = !state[action.massActionId].data
                .isTitleTumblerChecked;
            const isOldTitleActive =
                state[action.massActionId].data.isTitleTumblerChecked;
            const isAdditionalTextActive =
                state[action.massActionId].data.isAdditionalTextTumblerChecked;
            const isSiteLinksActive =
                state[action.massActionId].data.isSiteLinksTumblerChecked;

            const [
                isTitleTumblerChecked,
                isAdditionalTextTumblerChecked,
                isSiteLinksTumblerChecked
            ] = getMassActionsCheckBoxState(
                [isTitleActive, isAdditionalTextActive, isSiteLinksActive],
                [isOldTitleActive, isAdditionalTextActive, isSiteLinksActive]
            );

            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        isTitleTumblerChecked,
                        isAdditionalTextTumblerChecked,
                        isSiteLinksTumblerChecked
                    }
                }
            };
        }
        case CHANGE_MASS_ACTIONS_TEXT_BULK_ADDITIONAL_TEXT_TUMBLER: {
            const isTitleActive =
                state[action.massActionId].data.isTitleTumblerChecked;
            const isOldAdditionalTextActive =
                state[action.massActionId].data.isAdditionalTextTumblerChecked;
            const isAdditionalTextActive = !state[action.massActionId].data
                .isAdditionalTextTumblerChecked;
            const isSiteLinksActive =
                state[action.massActionId].data.isSiteLinksTumblerChecked;

            const [
                isTitleTumblerChecked,
                isAdditionalTextTumblerChecked,
                isSiteLinksTumblerChecked
            ] = getMassActionsCheckBoxState(
                [isTitleActive, isAdditionalTextActive, isSiteLinksActive],
                [isTitleActive, isOldAdditionalTextActive, isSiteLinksActive]
            );

            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        isTitleTumblerChecked,
                        isAdditionalTextTumblerChecked,
                        isSiteLinksTumblerChecked
                    }
                }
            };
        }
        case CHANGE_MASS_ACTIONS_TEXT_BULK_RADIO: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        currentTextBulkRadioState: action.value
                    }
                }
            };
        }
        case CHANGE_MASS_ACTIONS_TEXT_BULK_NEW_TEXT: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        newText: action.newText
                    }
                }
            };
        }
        case ON_MASS_ACTIONS_TEXT_BULK_SOURCE_TEXT_CHANGE: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        sourceText: action.text
                    }
                }
            };
        }
        default:
            return state;
    }
}
